export default "__VITE_ASSET__DwLlv13J__"